import { Component, OnInit } from "@angular/core";
import { RedirectService } from "@core/services";
import { assetUrl } from "@shared/helper/asset-url";

@Component({
  selector: "app-driveb-not-found-route",
  templateUrl: "./not-found-route.component.html",
  styleUrls: ["./not-found-route.component.scss"],
  standalone: false
})
export class NotFoundRouteComponent implements OnInit {
  imgPath = assetUrl("img/icons-driveb/driveb-not-found.png");
  homeUrl = "";

  constructor(private redirectService: RedirectService) {}

  ngOnInit(): void {
    this.redirectService.getHomeUrl$().subscribe((homeUrl) => {
      this.homeUrl = `/${homeUrl}`;
    });
  }
}
